
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      playerReady: false,
      playing: false,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.border = this.blok.border
      styles.borderRadius = this.getBreakpointValue(this.blok.borderRadius)
      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.width = this.getBreakpointValue(this.blok.width)
      styles.height = this.getBreakpointValue(this.blok.height)

      return styles
    },
  },
  methods: {
    onLoad() {
      // set classes for iframe
      this.$refs.player.$el
        .querySelector('iframe')
        .classList.add(
          'rounded-xl',
          'absolute',
          'w-full',
          'h-full',
          'top-0',
          'left-0'
        )

      this.playerReady = true
    },
    playingVideo() {
      this.playing = true
    },
  },
}
